import { ReactNode } from 'react'
import {
  SWrapper,
  STextWrapper,
  STitle,
  STitleRow,
  SActionLabel,
  SActionWrapper,
  SDescription,
} from './HighlightedParagraph.styled'
import { LinkProps } from 'next/link'
import { encodeQuery } from 'utils/fetcher'
import { useRouter } from 'next/router'
import { Icon, IconName, IconProps } from 'components/icon'
import { InterpolationPrimitive } from '@emotion/serialize'
export interface HighlightedParagraphProps {
  icon?: IconName
  iconProps?: IconProps
  linkProps?: LinkProps
  title: ReactNode
  description?: ReactNode
  actionLabel?: string
  hideAction?: boolean
  disabled?: boolean
  wrapperCss?: InterpolationPrimitive
}

export function HighlightedParagraph(props: HighlightedParagraphProps) {
  const router = useRouter()

  const hasDescription = !!props.description
  const hasActionLabel = !!props.actionLabel
  const hasIcon = !!props.icon

  return (
    <SWrapper
      type="button"
      href={
        props.disabled
          ? undefined
          : encodeQuery(props.linkProps?.href as string, {
              inside: router.pathname?.includes('/me/'),
            })
      }
      as={props.linkProps?.as}
      variant="secondary"
      hasActionLabel={hasActionLabel}
      css={props.wrapperCss}
      style={{ pointerEvents: props.disabled ? 'none' : 'all' }}
    >
      <STextWrapper noDescription={!hasDescription}>
        <STitleRow hasIcon={hasIcon}>
          {hasIcon && <Icon name={props.icon} {...props.iconProps} />}
          <STitle as="h3">{props.title}</STitle>
        </STitleRow>
        {hasDescription && <SDescription>{props.description}</SDescription>}
      </STextWrapper>
      {!props.hideAction && !props.disabled && (
        <SActionWrapper hasActionLabel={hasActionLabel}>
          {!!props.actionLabel && <SActionLabel>{props.actionLabel}</SActionLabel>}
          <Icon name="ArrowRight" />
        </SActionWrapper>
      )}
    </SWrapper>
  )
}
